
























import Vue from 'vue'
import ProfileModalContent from '@/components/modal/ProfileModal/ProfileModalContent.vue'
import FullModalLayout from '@/components/modal/basics/FullModal/FullModalLayout.vue'
import FullModalHeaderCloseButton from '@/components/modal/basics/FullModal/FullModalHeader/FullModalHeaderCloseButton.vue'
import FullModalHeaderTitle from '@/components/modal/basics/FullModal/FullModalHeader/FullModalHeaderTitle.vue'
import Steps from '@/components/globals/basics/Steps.vue'
import { applyConversionTag } from '@/tools/moshimo'
import { User } from '@/core/Auth'

export default Vue.extend({
  components: {
    FullModalLayout,
    FullModalHeaderCloseButton,
    FullModalHeaderTitle,
    ProfileModalContent,
    Steps,
  },
  data() {
    return {
      destroyScript: null as (() => void) | null,
    }
  },
  computed: {
    user(): User {
      return this.$store.getters['auth/user']
    },
  },
  methods: {
    onBeforeModalOpen(): void {
      // ユーザ名が登録されていれば何もしない
      if (this.user.name) return

      // 初回登録でユーザ名が登録されていない場合はコンバージョンタグをページに埋め込む
      this.destroyScript = applyConversionTag(this.user.id)
    },
    onBeforeModalClose(): void {
      if (this.destroyScript) {
        this.destroyScript()
      }
    },
    onClose() {
      this.$modal.pop()
      this.$emit('onClose')
    },
  },
})
